export default "__VITE_ASSET__Q0B7rmU6__"